import React, { FC } from 'react';
import { InfoHeaderSkeleton as HeaderSkeleton } from '@whitesharx/starfall-frontend-core';
import { Icon } from '@whitesharx/starfall-frontend-ui-kit';
import { barsContainerStyles } from './styles.css';

const MenuButton = () => {
  return (
    <div className={barsContainerStyles}>
      <Icon name="bars" size="18" color="white" />
    </div>
  );
};

export const InfoHeaderSkeleton: FC = () => <HeaderSkeleton rightSlot={<MenuButton />} />;
